// impure
export const appRoutesI18nCache: Record<string, string> = {};
